import { PERMISSIONS } from '@basqet-dashboard/common/config';

const SETTING_TABS = [
  {
    name: 'KYC settings',
    value: 'kyc',
    permission: PERMISSIONS.SETTINGS_MANAGE
  },
  {
    name: 'Business settings',
    value: 'business',
    permission: PERMISSIONS.SETTINGS_MANAGE
  },
  {
    name: 'Settlement settings',
    value: 'settlement',
    permission: PERMISSIONS.SETTLEMENTS_MANAGE
  },
  {
    name: 'Beneficiary settings',
    value: 'beneficiary',
    permission: PERMISSIONS.BENEFICIARIES_VIEW
  },
  {
    name: 'Security settings',
    value: 'security'
  },
  {
    name: 'Teams',
    value: 'teams'
  }
];
export { SETTING_TABS };
